<ng-container>
	<div mat-dialog-title class="mat-dialog-header">
		<h2 class="dialog-title">Recent changes</h2>
	</div>
	<div mat-dialog-content class="recent-changes-content">
		<p class="recent-changes-intro">Evaluations and Scheduled Actions rescheduled in the last 48 hours for the samples matching your filter.</p>

		<div *ngIf="(status$ | async) === Status.LOADING || (status$ | async) === Status.UNINITIALIZED" class="recent-changes-state">
			<mat-spinner diameter="28"></mat-spinner>
			<span>Loading recent changes...</span>
		</div>

		<div *ngIf="(status$ | async) !== Status.OK && (status$ | async) !== Status.LOADING && (status$ | async) !== Status.UNINITIALIZED" class="recent-changes-state">
			<span class="text-warn">Recent changes could not be loaded.</span>
			<button type="button" mat-stroked-button (click)="retry()">Try again</button>
		</div>

		<div *ngIf="(status$ | async) === Status.OK && (rows$ | async)?.length === 0" class="recent-changes-state">
			<span>No changes in the last 48 hours.</span>
		</div>

		<table *ngIf="(status$ | async) === Status.OK && (rows$ | async)?.length > 0" class="recent-changes-table">
			<thead>
				<tr>
					<th>Item</th>
					<th>Cultivar and site</th>
					<th>Previous date</th>
					<th>New date</th>
					<th>Changed</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let row of rows$ | async">
					<tr *ngIf="row.actionType !== 'destroy'">
						<td>
							<div class="recent-changes-type">{{ row.type }}</div>
							<div>{{ row.title }}</div>
						</td>
						<td>
							<div>{{ row.cultivarName }}</div>
							<div class="recent-changes-muted">{{ row.site }}</div>
						</td>
						<td>{{ row.previousDate | date:'d MMM yyyy' }}</td>
						<td>{{ row.newDate | date:'d MMM yyyy' }}</td>
						<td>{{ row.changedAt | date:'d MMM, HH:mm' }}</td>
					</tr>
					<tr *ngIf="row.actionType === 'destroy'">
						<td colspan="5">
							<div class="recent-changes-warning-block">
								<div class="recent-changes-warning-label">{{ row.title }} — irreversible</div>
								<div>{{ row.cultivarName }} — {{ row.site }}</div>
								<div class="recent-changes-muted">Rescheduled {{ row.previousDate | date:'d MMM yyyy' }} → {{ row.newDate | date:'d MMM yyyy' }} on {{ row.changedAt | date:'d MMM, HH:mm' }}</div>
							</div>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
	<div mat-dialog-actions class="recent-changes-actions">
		<button type="button" mat-stroked-button (click)="close()">Close</button>
	</div>
</ng-container>
